<template>
  <div id="app">
    <vue-headful
            title="TFTHub - Scouting & matchmaking app"
            description="TFT Hub Matchmaking app will help you track and show potential enemies in next round, making your scouting easier and better! The best and most advanced Teamfight Tactics Scouting app!"
            keywords="tft,teamfight tactics,matchmaking,scouting,scouting app,matchmaking app"
    />
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
  import Footer from './components/Footer.vue'

  export default {
    name: 'App',
    components: {
      Footer
    }
  }
</script>

<style>
  html {
    background-color: #0f1112;
    color: #c9c7c4;
  }

  body {
    margin: 0;
  }

  input {
    color: #c9c7c4;
  }

  a {
    color: #42b983;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /*color: #2c3e50;*/
  }
</style>
